import React, { useState } from "react";
import { Lead, LeadStatus, LeadOutcome } from "./types/LeadTypes";
import LeadModals from "./modals";
import LeadListItem from "./mobile/LeadListItem";
import { formatTranscriptForDisplay } from "./utils/transcriptUtils";

interface MobileLeadListProps {
  leads: Lead[];
  onStatusChange: (id: string, status: LeadStatus) => void;
  onOutcomeChange: (id: string, outcome: LeadOutcome | null) => void;
  onValueChange: (id: string, value: string) => void;
  onNameChange: (id: string, name: string) => void;
}

const MobileLeadList: React.FC<MobileLeadListProps> = ({
  leads,
  onStatusChange,
  onOutcomeChange,
  onValueChange,
  onNameChange,
}) => {
  const [editingName, setEditingName] = useState<string | null>(null);
  const [transcriptModalOpen, setTranscriptModalOpen] = useState(false);
  const [activeLeadId, setActiveLeadId] = useState<string | null>(null);
  const [expandedLeadId, setExpandedLeadId] = useState<string | null>(null);

  const openNameModal = (id: string) => {
    setEditingName(id);
  };

  const closeNameModal = () => {
    setEditingName(null);
  };

  const handleNameChange = (id: string, newName: string) => {
    onNameChange(id, newName);
    closeNameModal();
  };

  const openTranscriptModal = (id: string) => {
    setActiveLeadId(id);
    setTranscriptModalOpen(true);
  };

  const closeTranscriptModal = () => {
    setTranscriptModalOpen(false);
    setActiveLeadId(null);
  };

  const handleToggleExpand = (id: string) => {
    setExpandedLeadId(expandedLeadId === id ? null : id);
  };

  return (
    <div className="space-y-0 w-full overflow-hidden">
      {leads.map((lead) => (
        <LeadListItem
          key={lead.id}
          lead={lead}
          onStatusChange={onStatusChange}
          onOutcomeChange={onOutcomeChange}
          onValueChange={onValueChange}
          onNameChange={onNameChange}
          openNameModal={openNameModal}
          openTranscriptModal={openTranscriptModal}
          isExpanded={expandedLeadId === lead.id}
          onToggleExpand={handleToggleExpand}
        />
      ))}

      <LeadModals
        editingName={editingName}
        transcriptModalOpen={transcriptModalOpen}
        activeLeadId={activeLeadId}
        initialName={leads.find((l) => l.id === editingName)?.name || ""}
        transcript={
          activeLeadId
            ? formatTranscriptForDisplay(
                leads.find((l) => l.id === activeLeadId) || leads[0]
              )
            : []
        }
        onCloseNameModal={closeNameModal}
        onCloseTranscriptModal={closeTranscriptModal}
        onSaveName={handleNameChange}
      />
    </div>
  );
};

export default MobileLeadList;
